import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMonetizationRequest } from "../../store/monetization/monetization.action";
import Table from "../../Component/Common/Table";
import Pagination from "../../Component/Common/Pagination";
import { covertURl } from "../../util/AwsFunction";

const DeclinedRequest = (props) => {
  const { monetization, total } = useSelector((state) => state.monetization);

  const dispatch = useDispatch();

  console.log("monetizationmonetization", monetization);
  const { startDate, endDate } = props;

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [showURLs, setShowURLs] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(getMonetizationRequest(3, page, size, startDate, endDate));
  }, [dispatch, page, size, startDate, endDate]);

  useEffect(() => {
    setData(monetization);
  }, [monetization]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  useEffect(() => {
    fetchData();
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      return;
    }

    const urls = await Promise.all(
      data.map(async (item) => {
        const fileNameWithExtension = item?.userId?.image.split("/").pop();
        const { imageURL } = await covertURl(
          "userImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowURLs(urls);
  };

  const ManageUserData = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },

    {
      Header: "USERNAME",
      body: "userName",
      Cell: ({ row, index }) => (
        <div
          className="d-flex align-items-center "
          style={{ cursor: "pointer" }}
        >
          <img src={showURLs[index]} width="40px" height="40px" />
          <span className="text-capitalize    text-nowrap">
            {row?.userId?.fullName}
          </span>
        </div>
      ),
    },
    {
      Header: "Total Watch Time (Minutes)",
      body: "totalWatchTime",
      Cell: ({ row }) => (
        <span className="text-lowercase ">{row?.totalWatchTime}</span>
      ),
    },
    {
      Header: "Total Watch Time (Hours)",
      body: "totalWatchTimeInHours",
      Cell: ({ row }) => (
        <span className="text-lowercase ">{row?.totalWatchTimeInHours}</span>
      ),
    },
    {
      Header: "CreatedAt",
      body: "createdAt",
      Cell: ({ row }) => <span>{row?.requestDate}</span>,
    },

    {
      Header: "Status",
      body: "action",
      Cell: ({ row }) => <div className="badge text-danger">Declined</div>,
    },
  ];
  return (
    <div>
      <div className="user-table real-user mb-3">
        <div className="user-table-top">
          <h5
            style={{
              fontWeight: "500",
              fontSize: "20px",
              marginBottom: "5px",
              marginTop: "5px",
            }}
          >
            Monetization Request Table
          </h5>
        </div>
        <Table
          data={data}
          mapData={ManageUserData}
          noDataMessage="No Monetization Request Found!"
        />
        <Pagination
          totalItem={total}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </div>
  );
};

export default DeclinedRequest;
